import type {
  AgentCreateProjectLinkInput,
  AgentListAvailableProjectsParams,
  AgentListMyProjectsParams,
  AgentListProjectsParams,
  AgentToggleProjectLinkActiveInput,
} from '../api'
import { api } from '../api'

const getAgentListProjects = async (data: AgentListProjectsParams) => {
  return await api.v1.agentListProjects(data)
}

const getAgentProjectDetails = async (token: string) => {
  return await api.v1.agentGetProjectDetails({ token })
}

const agentCreateProjectLink = async (
  data: AgentCreateProjectLinkInput,
  token: string,
) => {
  return await api.v1.agentCreateProjectLink({ token }, data)
}

const agentToggleProjectLinkActive = async (
  data: AgentToggleProjectLinkActiveInput,
  token: string,
) => {
  return await api.v1.agentToggleProjectLinkActive({ token }, data)
}

const agentListMyProjects = async (data: AgentListMyProjectsParams) => {
  return await api.v1.agentListMyProjects(data)
}

const agentListAvailableProjects = async (
  data: AgentListAvailableProjectsParams,
) => {
  return await api.v1.agentListAvailableProjects(data)
}

export default {
  getAgentProjectDetails,
  getAgentListProjects,
  agentCreateProjectLink,
  agentToggleProjectLinkActive,
  agentListMyProjects,
  agentListAvailableProjects,
}
